import { __awaiter, __generator, __read } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import styles from './TextTranslator.module.less';
import { FilledOtherTranslate, OutlinedDirectionRefresh, OutlinedEditCopy, OutlinedTipsClose } from '@hose/eui-icons';
import { Button, message, Spin } from '@hose/eui';
import { Fetch } from '@ekuaibao/fetch';
export var TextTranslator = function (_a) {
    var translateConfig = _a.translateConfig, isClose = _a.isClose;
    var _b = __read(useState(''), 2), selectedText = _b[0], setSelectedText = _b[1];
    var _c = __read(useState(''), 2), translationText = _c[0], setTranslationText = _c[1];
    var _d = __read(useState({ x: 0, y: 0 }), 2), position = _d[0], setPosition = _d[1];
    var translationContainerRef = useRef(null);
    var _e = __read(useState('idle'), 2), translationStatus = _e[0], setTranslationStatus = _e[1];
    var _f = __read(useState('idle'), 2), showTranslatorStatus = _f[0], setShowTranslatorStatus = _f[1];
    useEffect(function () {
        document.addEventListener('mouseup', handleMouseUp);
        return function () {
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, []);
    var handleMouseUp = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var selection, text, range, rect;
        var _a;
        return __generator(this, function (_b) {
            e.preventDefault();
            selection = window.getSelection();
            setShowTranslatorStatus('idle');
            if (!selection || selection.isCollapsed || localStorage.getItem(Fetch.ekbCorpId + "_enableHyperTranslate") === 'close') {
                return [2];
            }
            if ((_a = translationContainerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
                return [2];
            }
            text = selection.toString().trim();
            if (!text) {
                return [2];
            }
            range = selection.getRangeAt(0);
            rect = range.getBoundingClientRect();
            setPosition({
                x: rect.x + rect.width,
                y: rect.y + rect.height,
            });
            setSelectedText(text);
            setShowTranslatorStatus('icon');
            return [2];
        });
    }); };
    var getTranslation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1, popoverHeight, popoverWidth;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setShowTranslatorStatus('popover');
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    setTranslationStatus('loading');
                    return [4, translateConfig.translateText(selectedText)];
                case 2:
                    result = _c.sent();
                    setTranslationText(result);
                    setTranslationStatus('success');
                    return [3, 5];
                case 3:
                    error_1 = _c.sent();
                    setTranslationStatus('error');
                    console.error('Translation failed:', error_1);
                    return [3, 5];
                case 4:
                    popoverHeight = (_a = translationContainerRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
                    popoverWidth = (_b = translationContainerRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth;
                    if (position.y + popoverHeight > window.innerHeight || position.x + popoverWidth > window.innerWidth) {
                        setPosition({
                            x: position.x + popoverWidth > window.innerWidth ? position.x - popoverWidth : position.x,
                            y: position.y + popoverHeight > window.innerHeight ? position.y - popoverHeight : position.y,
                        });
                    }
                    return [7];
                case 5: return [2];
            }
        });
    }); };
    var renderIcon = function () {
        return (React.createElement(FilledOtherTranslate, { style: { position: 'fixed', left: position.x, top: position.y, background: '#fff' }, fontSize: 24, color: "var(--eui-primary-pri-500)", onMouseEnter: getTranslation }));
    };
    var renderPopover = function () {
        var content = (React.createElement("div", { ref: translationContainerRef, className: 'translator-popover', style: { position: 'fixed', left: position.x, top: position.y } },
            React.createElement("div", { className: 'popover-header' },
                React.createElement("div", { className: 'popover-header-title' },
                    React.createElement(FilledOtherTranslate, { fontSize: 32, color: "var(--eui-primary-pri-500)" }),
                    React.createElement("div", null, i18n.get('翻译'))),
                React.createElement("div", { className: 'popover-header-close' },
                    React.createElement(OutlinedTipsClose, { fontSize: 16, color: "var(--eui-icon-n2)", onClick: function () {
                            setSelectedText('');
                            setShowTranslatorStatus('idle');
                        } }))),
            React.createElement("div", { className: 'popover-content' },
                translationStatus === 'loading' &&
                    React.createElement("div", { className: 'popover-content-loading' },
                        React.createElement(Spin, { text: i18n.get('加载中...'), direction: "vertical" })),
                translationStatus === 'error' &&
                    React.createElement("div", { className: 'popover-content-error' },
                        React.createElement("div", null, i18n.get('翻译失败, 请重试')),
                        React.createElement(Button, { category: "text", theme: "highlight", icon: React.createElement(OutlinedDirectionRefresh, { fontSize: 20 }) }, i18n.get('刷新重试'))),
                translationStatus === 'success' &&
                    React.createElement("div", { className: 'popover-content-success' },
                        React.createElement("span", null, translationText),
                        React.createElement(OutlinedEditCopy, { fontSize: 16, className: 'copy-icon', color: "var(--eui-icon-n2)", onClick: function () {
                                navigator.clipboard.writeText(translationText);
                                message.success(i18n.get('复制成功'));
                            } })))));
        return content;
    };
    return (React.createElement("div", { className: styles['text-translator'] },
        showTranslatorStatus === 'icon' && renderIcon(),
        showTranslatorStatus === 'popover' && renderPopover()));
};
